import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApmService } from '@elastic/apm-rum-angular';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ENABLE_HTTP_LOGGING, HTTP_SERVICE_NAME } from './http-client-log.factory';
import { ApmBase } from '@elastic/apm-rum';
import { environment } from '../../../../environments/environment';

@Injectable()
export class HttpLoggingInterceptor implements HttpInterceptor {
    apmInstance: ApmBase;
    constructor(private elasticAPMService: ApmService) {
        this.apmInstance = this.elasticAPMService.apm;
    }

    /**
     * Cross-browser compatible high-resolution timestamp
     * Falls back to Date.now() for browsers without Performance API (IE9 and older)
     */
    private getTimestamp(): number {
        // Check if Performance API is available
        if (typeof performance !== 'undefined' && performance.now) {
            return performance.now();
        }
        // Fallback to Date.now() for older browsers
        return Date.now();
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Only log if the request explicitly enables logging via context
        const shouldLog = req.context.get(ENABLE_HTTP_LOGGING);

        if (!shouldLog) {
            return next.handle(req);
        }

        // Get the service name from context
        const serviceName = req.context.get(HTTP_SERVICE_NAME);

        // Skip console logging in production unless explicitly enabled
        const logToConsole = environment?.enableHttpLogging;

        const startTime = this.getTimestamp();
        const method = req.method;
        const url = req.url;

        // Log only to APM, not console (for production)
        return next.handle(req).pipe(
            tap({
                next: (event) => {
                    if (event instanceof HttpResponse) {
                        const endTime = this.getTimestamp();
                        const duration = endTime - startTime;

                        // Log to console if enabled
                        if (logToConsole) {
                            const logData: any = {
                                Service: serviceName,
                                Method: method,
                                Url: url,
                                Duration: `${duration.toFixed(2)}ms`,
                                Status: event.status,
                                StartOn: new Date(startTime).toISOString(),
                                EndOn: new Date(endTime).toISOString()
                            };

                            // Include request payload if present (POST, PUT, PATCH)
                            if (req.body) {
                                logData.requestPayload = req.body;
                            }

                            // Always add labels to APM for monitored requests
                            this.apmInstance?.addLabels(logData);
                        }
                    }
                }
            })
        );
    }
}
